var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCylinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0249 13.3804C4.0249 12.6421 4.51295 11.9039 5.50382 11.3354C7.46339 10.2059 10.6394 10.2059 12.5952 11.3354C13.575 11.9002 14.0742 12.6384 14.0742 13.3804",
    stroke: "#B7B7B7",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0249 3.91602V13.3804",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0493 13.3809C14.0493 14.1191 13.5575 14.8574 12.5703 15.4221C10.6145 16.5516 7.43849 16.5516 5.47892 15.4221C4.49914 14.8574 4 14.1191 4 13.3809",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03845 6.78052C11.8073 6.78052 14.052 5.4865 14.052 3.89026C14.052 2.29401 11.8073 1 9.03845 1C6.26954 1 4.0249 2.29401 4.0249 3.89026C4.0249 5.4865 6.26954 6.78052 9.03845 6.78052Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0573 3.91602V13.3804",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCylinder);
export default __webpack_public_path__ + "static/media/ic_cylinder.7a0a80ad49ef0081015f54fcab66cb96.svg";
export { ForwardRef as ReactComponent };